(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				if (this.headerOverlay) {
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				if (!this.classList.contains('mega-menu-open')) {
					this.headerOverlay.classList.add('color-inverse');
				}
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-before-sitewide-20pct-20261018"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
		constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: false,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				
					
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
				
			}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokani-collection-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mokani-collection-index')) {
    customElements.define('mokani-collection-index', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.rows = [...this.querySelectorAll('.mkci__row')];
        this.preview = this.querySelector('.mkci__preview');
        this.layers = [...this.preview.querySelectorAll('img')];
        this.fine = matchMedia('(hover:hover) and (pointer:fine) and (min-width:768px)');
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.front = 0;
        this.current = null;
        this.raf = 0;
        this.classList.add('is-enhanced');
        this.rows.forEach(row => {
          row.addEventListener('pointerenter', e => { if (this.fine.matches) this.show(row,e); }, {signal});
          row.addEventListener('pointermove', e => { if (this.fine.matches) this.show(row,e); }, {signal});
          row.addEventListener('pointerleave', () => this.hide(), {signal});
          row.addEventListener('focus', () => { if (this.fine.matches) this.show(row); }, {signal});
          row.addEventListener('blur', () => this.hide(), {signal});
          row.addEventListener('click', () => this.hide(), {signal});
        });
        this.querySelectorAll('.mkci__photo-button').forEach(button => {
          button.addEventListener('click', () => {
            const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
            const open = button.getAttribute('aria-expanded') !== 'true';
            this.querySelectorAll('.mkci__photo-button').forEach(other => other.setAttribute('aria-expanded','false'));
            this.querySelectorAll('.mkci__mobile-photo').forEach(other => { other.hidden = true; });
            button.setAttribute('aria-expanded',String(open));
            panel.hidden = !open;
          }, {signal});
        });
        this.addEventListener('pointerleave', () => this.hide(), {signal});
        this.addEventListener('keydown', e => { if (e.key === 'Escape') this.hide(); }, {signal});
        window.addEventListener('scroll', () => this.hide(), {passive:true,capture:true,signal});
        window.addEventListener('resize', () => this.hide(), {passive:true,signal});
        window.addEventListener('blur', () => this.hide(), {signal});
        document.addEventListener('visibilitychange', () => this.hide(), {signal});
        this.fine.addEventListener('change', () => this.hide(), {signal});
        this.reduced.addEventListener('change', () => this.hide(), {signal});
      }
      show(row,event) {
        const src = row.dataset.preview;
        if (!src) return;
        const rect = this.getBoundingClientRect();
        const bounds = row.getBoundingClientRect();
        const w = this.preview.offsetWidth, h = this.preview.offsetHeight;
        const staticMode = this.reduced.matches || !event;
        const x = staticMode ? rect.width-w-24 : event.clientX-rect.left+40;
        const y = staticMode ? bounds.top-rect.top+(bounds.height-h)/2 : event.clientY-rect.top-120;
        this.tx = Math.max(16,Math.min(x,rect.width-w-16));
        this.ty = Math.max(16,Math.min(y,rect.height-h-16));
        if (!this.current || staticMode) {
          this.x = this.tx; this.y = this.ty;
          this.preview.style.transform = `translate3d(${this.x}px,${this.y}px,0)`;
        }
        if (this.current !== row) {
          this.current = row;
          this.rows.forEach(other => other.classList.toggle('is-active',other === row));
          const next = this.layers[1-this.front];
          this.layers.forEach(layer => layer.getAnimations().forEach(animation => animation.cancel()));
          this.layers[this.front].style.zIndex = '1';
          next.src = src;
          next.style.zIndex = '2'; next.style.opacity = '1';
          if (!this.reduced.matches) next.animate([{opacity:0,transform:'scale(.8)'},{opacity:1,transform:'scale(1)'}],{duration:450,easing:'cubic-bezier(.22,1,.36,1)'});
          this.front = 1-this.front;
        }
        this.classList.add('has-preview');
        if (!staticMode && !this.raf) {
          this.lastFrame = performance.now();
          this.raf = requestAnimationFrame(time => this.tick(time));
        }
      }
      tick(time) {
        this.raf = 0;
        if (!this.current) return;
        const smoothing = 1-Math.exp(-Math.min(time-this.lastFrame,64)/110);
        this.lastFrame = time;
        this.x += (this.tx-this.x)*smoothing; this.y += (this.ty-this.y)*smoothing;
        this.preview.style.transform = `translate3d(${this.x}px,${this.y}px,0)`;
        if (Math.abs(this.tx-this.x)+Math.abs(this.ty-this.y)>.1) this.raf=requestAnimationFrame(t=>this.tick(t));
      }
      hide() {
        cancelAnimationFrame(this.raf); this.raf=0;
        this.current=null;
        this.classList.remove('has-preview');
        this.rows.forEach(row=>row.classList.remove('is-active'));
      }
      disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.raf); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokani-flip-wall"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mokani-flip-wall')) {
    customElements.define('mokani-flip-wall',class extends HTMLElement {
      connectedCallback() {
        if(this.controller)return;
        this.controller=new AbortController();this.wall=this.querySelector('.mkflip__wall');this.grid=this.querySelector('.mkflip__grid');
        this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.state=false;this.tiles=[];this.waving=false;
        const signal=this.controller.signal;
        this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.prepare();}},{rootMargin:'600px'});
        this.observer.observe(this);
        this.motion.addEventListener('change',()=>{if(this.motion.matches){this.clearTimers();this.waving=false;this.tiles.forEach(tile=>this.flip(tile,this.state));this.announce();}},{signal});
      }
      async prepare() {
        const controller=this.controller;
        const load=src=>new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=reject;image.src=src;});
        try {this.images=await Promise.all([load(this.dataset.front),load(this.dataset.back)]);}catch{return;}
        if(!this.isConnected||controller!==this.controller)return;
        this.grid.replaceChildren();this.tiles=[];
        this.style.setProperty('--flip-image-a',`url("${this.dataset.front}")`);this.style.setProperty('--flip-image-b',`url("${this.dataset.back}")`);
        const signal=this.controller.signal;
        for(let row=0;row<5;row++)for(let col=0;col<8;col++) {
          const element=document.createElement('div');element.className='mkflip__tile';element.dataset.index=String(this.tiles.length);
          for(const side of ['front','back']){const face=document.createElement('div');face.className=`mkflip__face mkflip__face--${side}`;element.append(face);}
          const tile={element,row,col,back:false};this.tiles.push(tile);this.grid.append(element);
          element.addEventListener('pointerenter',event=>{if(event.pointerType!=='mouse'||this.waving)return;clearTimeout(tile.returnTimer);this.flip(tile,!this.state);},{signal});
          element.addEventListener('pointerleave',event=>{if(event.pointerType!=='mouse'||this.waving)return;clearTimeout(tile.returnTimer);tile.returnTimer=setTimeout(()=>this.flip(tile,this.state),900);},{signal});
        }
        this.resize=new ResizeObserver(()=>this.layout());this.resize.observe(this.wall);this.layout();
        this.wall.setAttribute('role','button');this.wall.tabIndex=0;this.wall.setAttribute('aria-label',this.dataset.label);this.wall.setAttribute('aria-pressed','false');
        this.wall.addEventListener('click',event=>{if(performance.now()<(this.ignoreClickUntil||0))return;this.wave(this.tileAt(event.target)||this.tiles[19]);},{signal});
        this.wall.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();if(!event.repeat)this.wave(this.tiles[19]);}},{signal});
        this.wall.addEventListener('pointerdown',event=>{
          if(event.pointerType==='mouse'||!event.isPrimary)return;
          this.cancelTouch();const tile=this.tileAt(event.target);if(!tile)return;
          const touch={id:event.pointerId,x:event.clientX,y:event.clientY,tile,moved:false,long:false};this.touch=touch;
          this.longTimer=setTimeout(()=>{if(this.touch!==touch||touch.moved)return;touch.long=true;this.wave(tile);},450);
        },{passive:true,signal});
        this.wall.addEventListener('pointermove',event=>{const touch=this.touch;if(!touch||event.pointerId!==touch.id)return;if(Math.hypot(event.clientX-touch.x,event.clientY-touch.y)>10){touch.moved=true;clearTimeout(this.longTimer);}},{passive:true,signal});
        this.wall.addEventListener('pointerup',event=>{
          const touch=this.touch;if(!touch||event.pointerId!==touch.id)return;clearTimeout(this.longTimer);
          if(!touch.moved&&!touch.long&&!this.waving){clearTimeout(touch.tile.returnTimer);this.flip(touch.tile,!touch.tile.back);this.wall.setAttribute('aria-pressed','mixed');}
          this.ignoreClickUntil=performance.now()+700;this.touch=null;
        },{passive:true,signal});
        this.wall.addEventListener('pointercancel',()=>this.cancelTouch(),{passive:true,signal});
        this.wall.addEventListener('contextmenu',event=>{if(this.touch)event.preventDefault();},{signal});
        this.classList.add('is-ready');
      }
      tileAt(target) {const element=target.closest('.mkflip__tile');return element&&this.grid.contains(element)?this.tiles[Number(element.dataset.index)]:null;}
      layout() {
        const width=this.wall.clientWidth,height=this.wall.clientHeight;
        const crops=this.images.map((image,i)=>{const scale=Math.max(width/image.naturalWidth,height/image.naturalHeight),w=image.naturalWidth*scale,h=image.naturalHeight*scale,focus=Number(i?this.dataset.focusB:this.dataset.focusA)/100;return{w,h,x:(width-w)/2,y:(height-h)*focus};});
        crops.forEach((crop,i)=>this.style.setProperty(`--flip-size-${i?'b':'a'}`,`${crop.w}px ${crop.h}px`));
        this.tiles.forEach(tile=>crops.forEach((crop,i)=>tile.element.style.setProperty(`--flip-pos-${i?'b':'a'}`,`${crop.x-tile.element.offsetLeft}px ${crop.y-tile.element.offsetTop}px`)));
      }
      flip(tile,back) {tile.back=back;tile.element.classList.toggle('is-flipped',back);}
      clearTimers() {clearTimeout(this.waveEnd);this.tiles.forEach(tile=>{clearTimeout(tile.returnTimer);clearTimeout(tile.waveTimer);});}
      wave(origin) {
        this.clearTimers();this.state=!this.state;this.waving=true;
        let longest=0;
        this.tiles.forEach(tile=>{const delay=this.motion.matches?0:Math.hypot(tile.col-origin.col,tile.row-origin.row)*90;longest=Math.max(longest,delay);if(!delay)this.flip(tile,this.state);else tile.waveTimer=setTimeout(()=>this.flip(tile,this.state),delay);});
        const finish=()=>{this.waving=false;this.announce();};
        if(this.motion.matches)finish();else this.waveEnd=setTimeout(finish,longest+700);
      }
      announce() {this.wall.setAttribute('aria-pressed',String(this.state));this.querySelector('.mkflip__counter').textContent=this.state?'02 / 02':'01 / 02';this.querySelector('.mkflip__status').textContent=this.state?this.dataset.altB:this.dataset.altA;}
      cancelTouch() {clearTimeout(this.longTimer);if(this.touch)this.ignoreClickUntil=performance.now()+700;this.touch=null;}
      disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();this.resize?.disconnect();this.cancelTouch();this.clearTimers();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokani-opposite-scroll"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mokani-opposite-scroll')) {
    customElements.define('mokani-opposite-scroll',class extends HTMLElement {
      connectedCallback() {
        if(this.controller) return;
        this.controller=new AbortController();const signal=this.controller.signal;
        this.stage=this.querySelector('.mkduet__stage');
        this.columns=[...this.querySelectorAll('.mkduet__column')];
        if(this.columns.some(column=>!column.querySelector('.mkduet__item')))return;
        this.motion=matchMedia('(prefers-reduced-motion:reduce)');
        this.current=0;this.target=0;this.visible=false;this.raf=0;
        this.style.setProperty('--duet-travel','180svh');this.classList.add('is-ready');
        this.build();
        this.onScroll=()=>{this.updateTarget();if(this.visible)this.run();};
        window.addEventListener('scroll',this.onScroll,{passive:true,signal});
        this.motion.addEventListener('change',this.onScroll,{signal});
        this.observer=new IntersectionObserver(entries=>{
          this.visible=entries[0].isIntersecting;
          if(this.visible){this.updateTarget();this.current=this.target;this.draw();this.run();}
          else{cancelAnimationFrame(this.raf);this.raf=0;}
        });
        this.observer.observe(this.stage);
        this.resize=new ResizeObserver(entries=>{
          const rect=entries[0].contentRect,key=`${rect.width}:${rect.height}`;
          if(key===this.sizeKey)return;this.sizeKey=key;this.build();
        });
        this.resize.observe(this.stage);
        document.addEventListener('visibilitychange',()=>{
          if(document.hidden){cancelAnimationFrame(this.raf);this.raf=0;}
          else this.onScroll();
        },{signal});
      }
      build() {
        this.lengths=this.columns.map(column=>{
          column.querySelectorAll('[data-duet-copy]').forEach(copy=>copy.remove());
          const set=column.querySelector('.mkduet__set'),length=set.getBoundingClientRect().height;
          if(!length)return 1;
          const copies=Math.ceil(this.stage.clientHeight/length)+1;
          for(let i=0;i<copies;i++){
            const copy=set.cloneNode(true);copy.dataset.duetCopy='';copy.setAttribute('aria-hidden','true');
            copy.querySelectorAll('[data-shopify-editor-block]').forEach(item=>item.removeAttribute('data-shopify-editor-block'));
            copy.querySelectorAll('img').forEach(img=>img.alt='');column.appendChild(copy);
          }
          return length;
        });
        this.travel=Math.max(this.stage.clientHeight*1.5,...this.lengths);
        this.style.setProperty('--duet-travel',`${this.travel}px`);
        this.updateTarget();this.current=this.target;this.draw();
      }
      updateTarget() {this.target=Math.max(0,Math.min(this.travel,-this.getBoundingClientRect().top));}
      run() {if(!this.raf&&!document.hidden){this.last=performance.now();this.raf=requestAnimationFrame(now=>this.tick(now));}}
      tick(now) {
        this.raf=0;const dt=Math.min((now-this.last)/1000,.064);this.last=now;
        this.current=this.motion.matches?this.target:this.current+(this.target-this.current)*(1-Math.exp(-dt/.16));
        if(Math.abs(this.target-this.current)<.1)this.current=this.target;
        this.draw();
        if(this.visible&&this.current!==this.target)this.raf=requestAnimationFrame(time=>this.tick(time));
      }
      draw() {
        this.columns.forEach((column,i)=>{
          const length=this.lengths[i],d=((this.current%length)+length)%length;
          column.style.transform=`translate3d(0,${column.dataset.direction==='down'?d-length:-d}px,0)`;
        });
      }
      disconnectedCallback() {this.controller?.abort();this.controller=null;this.observer?.disconnect();this.resize?.disconnect();cancelAnimationFrame(this.raf);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokani-orbit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mokani-orbit')) {
    customElements.define('mokani-orbit', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.stage = this.querySelector('.mokani-orbit__stage');
        this.cards = [...this.querySelectorAll('.mokani-orbit__card')];
        if (!this.cards.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('.mokani-orbit__pause');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.yaw = .4;
        this.pitch = 0;
        this.velocity = 0;
        this.elapsed = 0;
        this.visible = true;
        this.paused = false;
        this.suppressClick = false;
        this.points = this.cards.map((card, i) => {
          const y = 1 - 2 * (i + .5) / this.cards.length;
          const r = Math.sqrt(1 - y * y);
          const a = i * Math.PI * (3 - Math.sqrt(5));
          return { x: Math.cos(a) * r, y, z: Math.sin(a) * r };
        });
        this.classList.add('is-ready');
        this.resize = new ResizeObserver(() => {
          this.width = this.stage.clientWidth;
          this.height = this.stage.clientHeight;
          this.draw();
        });
        this.resize.observe(this.stage);
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { rootMargin: '100px' });
        this.intersection.observe(this);
        this.tick = time => {
          this.frame = null;
          const dt = Math.min((time - (this.lastTime || time)) / 1000, .05);
          this.lastTime = time;
          if (!this.paused && !this.reduced.matches && !this.activeCard && !this.pointer) {
            this.yaw += (Math.PI * 2 / 50 + this.velocity) * dt;
            this.velocity *= Math.exp(-dt / .7);
            this.pitch *= Math.exp(-dt / 1.1);
            this.elapsed += dt;
          }
          this.draw();
          this.schedule();
        };
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.button.querySelector('span').textContent = this.button.dataset[this.paused ? 'play' : 'pause'];
          this.schedule();
        }, options);
        this.stage.addEventListener('pointerover', event => {
          if (event.pointerType === 'touch' || this.pointer) return;
          this.hoverCard = event.target.closest('.mokani-orbit__card');
          this.updateActive();
        }, options);
        this.stage.addEventListener('pointerleave', () => {
          this.hoverCard = null;
          this.updateActive();
        }, options);
        this.stage.addEventListener('focusin', event => {
          this.focusCard = event.target.closest('.mokani-orbit__card');
          this.updateActive();
        }, options);
        this.stage.addEventListener('focusout', event => {
          this.focusCard = event.relatedTarget?.closest('.mokani-orbit__card');
          this.updateActive();
        }, options);
        this.stage.addEventListener('pointerdown', event => {
          if (event.button !== 0 || this.reduced.matches) return;
          this.suppressClick = false;
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, lastY: event.clientY, time: performance.now(), touch: event.pointerType === 'touch', dragging: false };
        }, options);
        this.stage.addEventListener('pointermove', event => {
          const p = this.pointer;
          if (!p || p.id !== event.pointerId) return;
          const dx = event.clientX - p.x;
          const dy = event.clientY - p.y;
          if (!p.dragging) {
            if (Math.abs(dx) + Math.abs(dy) < 8) return;
            if (p.touch && Math.abs(dy) > Math.abs(dx)) { this.pointer = null; return; }
            p.dragging = true;
            this.suppressClick = true;
            this.stage.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
            this.hoverCard = null;
            this.updateActive();
          }
          const now = performance.now();
          this.yaw += (event.clientX - p.lastX) * .006;
          this.pitch = Math.max(-.436, Math.min(.436, this.pitch + (event.clientY - p.lastY) * .004));
          this.velocity = Math.max(-6, Math.min(6, (event.clientX - p.lastX) * .006 / Math.max(.016, (now - p.time) / 1000)));
          p.lastX = event.clientX;
          p.lastY = event.clientY;
          p.time = now;
          this.draw();
        }, options);
        const endDrag = event => {
          if (this.pointer?.id !== event.pointerId) return;
          if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
          this.pointer = null;
          this.classList.remove('is-dragging');
          this.schedule();
        };
        window.addEventListener('pointerup', endDrag, options);
        this.stage.addEventListener('pointercancel', endDrag, options);
        this.stage.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; }
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', () => { this.draw(); this.schedule(); }, options);
        this.schedule();
      }
      updateActive() {
        this.activeCard = this.focusCard || this.hoverCard;
        this.draw();
        this.schedule();
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        if (!this.tick || !this.visible || document.hidden || this.paused || this.reduced.matches || this.activeCard || this.pointer) { this.lastTime = null; return; }
        this.frame = requestAnimationFrame(this.tick);
      }
      draw() {
        if (!this.width) return;
        const mobile = this.width < 768;
        const rx = mobile ? Math.min(this.width * .66, this.height * .38) : this.width * .43;
        const ry = mobile ? this.width * .29 : this.height * .28;
        const roll = mobile ? 80 * Math.PI / 180 : 0;
        const cy = Math.cos(this.yaw), sy = Math.sin(this.yaw), cp = Math.cos(this.pitch), sp = Math.sin(this.pitch);
        this.cards.forEach((card, i) => {
          const p = this.points[i];
          const x = p.x * cy + p.z * sy;
          const z0 = -p.x * sy + p.z * cy;
          const y = p.y * cp - z0 * sp;
          const z = p.y * sp + z0 * cp;
          const depth = (z + 1) / 2;
          const active = card === this.activeCard;
          const px = x * rx * Math.cos(roll) - y * ry * Math.sin(roll);
          const py = x * rx * Math.sin(roll) + y * ry * Math.cos(roll) + (this.reduced.matches ? 0 : Math.sin(this.elapsed * Math.PI / 2 + i) * 6);
          const scale = (.42 + depth * .58) * (active ? 1.15 : 1);
          card.style.transform = `translate(-50%, -50%) translate(${px.toFixed(2)}px, ${py.toFixed(2)}px) scale(${scale.toFixed(3)})`;
          card.style.opacity = active ? '1' : String(.3 + depth * .7);
          card.style.zIndex = active ? '1100' : String(Math.round(depth * 998));
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mokani-scene-wipes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mokani-scene-wipes')) {
    class MokaniSceneWipes extends HTMLElement {
      connectedCallback() {
        if(this.controller) return;
        this.controller=new AbortController(); const signal=this.controller.signal;
        this.stage=this.querySelector('.mksw__stage');
        this.scenes=[...this.querySelectorAll('.mksw__scene')].map(layer=>({layer,inner:layer.querySelector('.mksw__inner'),word:layer.querySelector('.mksw__word'),card:layer.querySelector('.mksw__card'),lines:[...layer.querySelector('.mksw__card').children]}));
        if(!this.scenes.length) return;
        this.motion=matchMedia('(prefers-reduced-motion:reduce)');
        this.pos=0;this.intro=1;this.raf=0;
        this.style.setProperty('--scene-count',this.scenes.length);
        this.classList.add('is-enhanced');
        this.onPageScroll=()=>{if(!this.raf)this.raf=requestAnimationFrame(()=>{this.raf=0;this.update();});};
        window.addEventListener('scroll',this.onPageScroll,{passive:true,signal});
        window.addEventListener('resize',this.onPageScroll,{passive:true,signal});
        this.motion.addEventListener('change',this.onPageScroll,{signal});
        this.stage.addEventListener('click',e=>{
          const exit=e.target.closest('[data-exit]');
          if(exit) {this.exit(exit.dataset.exit);return;}
          const step=e.target.closest('[data-step]');
          if(step) this.step(Number(step.dataset.step));
        },{signal});
        this.stage.addEventListener('keydown',e=>{
          if(e.target.closest('button,a,input,select,textarea')) return;
          if(e.key==='Escape') {e.preventDefault();this.exit('forward');return;}
          const forward=['ArrowDown','PageDown'].includes(e.key)||(e.key===' '&&!e.shiftKey);
          const back=['ArrowUp','PageUp'].includes(e.key)||(e.key===' '&&e.shiftKey);
          if(forward||back) {e.preventDefault();this.step(forward?1:-1);}
        },{signal});
        document.addEventListener('shopify:block:select',e=>{
          const i=this.scenes.findIndex(s=>s.layer.contains(e.target));
          if(i>=0)this.goTo(i);
        },{signal});
        this.resize=new ResizeObserver(this.onPageScroll);this.resize.observe(this.stage);
        this.update();
      }
      geometry() {
        return {start:window.scrollY+this.getBoundingClientRect().top,travel:Math.max(0,this.offsetHeight-this.stage.offsetHeight)};
      }
      update() {
        const {start,travel}=this.geometry();
        this.pos=travel?Math.max(0,Math.min(this.scenes.length-1,(window.scrollY-start)/travel*(this.scenes.length-1))):0;
        this.render();
        const i=Math.round(this.pos);
        if(this.announced!==i){this.announced=i;this.querySelector('.mksw__status').textContent=this.scenes[i].card.textContent.trim();}
      }
      goTo(index) {
        const {start,travel}=this.geometry();
        window.scrollTo({top:start+travel*index/Math.max(1,this.scenes.length-1),behavior:this.motion.matches?'instant':'smooth'});
      }
      step(direction) {
        this.update();
        const index=direction>0?Math.floor(this.pos+.001)+1:Math.ceil(this.pos-.001)-1;
        if(index<0 || index>=this.scenes.length){this.exit(direction>0?'forward':'back');return;}
        this.goTo(index);
      }
      exit(direction) {
        const wrapper=this.closest('.shopify-section')||this;
        const destination=direction==='back'?wrapper.previousElementSibling:(wrapper.nextElementSibling||document.querySelector('footer'));
        this.stage.querySelector(':focus')?.blur();this.stage.blur();
        const {start}=this.geometry();
        window.scrollTo({top:direction==='back'?Math.max(0,start-this.stage.offsetHeight):start+this.offsetHeight,behavior:this.motion.matches?'instant':'smooth'});
        if(destination){const added=!destination.hasAttribute('tabindex');if(added)destination.setAttribute('tabindex','-1');destination.focus({preventScroll:true});if(added)destination.addEventListener('blur',()=>destination.removeAttribute('tabindex'),{once:true});}
      }
      render() {
        const pos=this.motion.matches?Math.round(this.pos):this.pos,base=Math.floor(pos),f=pos-base,current=base,next=base+1;
        const clamp=x=>Math.max(0,Math.min(1,x)),smooth=x=>{x=clamp(x);return x*x*(3-2*x);},ease=x=>1-Math.pow(1-x,3);
        this.scenes.forEach((s,i)=>{
          const isCurrent=i===current,isNext=i===next&&this.scenes.length>1,y=isCurrent?0:isNext?(1-f)*100:100;
          s.layer.style.visibility=isCurrent||isNext?'visible':'hidden';s.layer.style.zIndex=isNext?'2':'1';s.layer.style.transform=`translate3d(0,${y}%,0)`;s.inner.style.transform=`translate3d(0,${-y}%,0)`;
          const selected=i===Math.round(pos);s.layer.inert=!selected;s.layer.setAttribute('aria-hidden',String(!selected));
          let t=isCurrent?1-smooth(f/.4):isNext?smooth((f-.55)/.45):0;t*=this.motion.matches?1:this.intro;
          s.card.style.opacity=t;s.card.style.transform=`translate3d(0,${(1-t)*34}px,0)`;
          s.word.style.transform=`translate3d(0,${this.motion.matches?0:isCurrent?-ease(f)*6:isNext?(1-ease(f))*22:0}vh,0)`;
          s.lines.forEach((line,k)=>{const kt=smooth((t-k*.07)/(1-.07*(s.lines.length-1)));line.style.opacity=kt;line.style.transform=`translate3d(0,${(1-kt)*16}px,0)`;});
        });
        this.querySelector('.mksw__counter').textContent=`${String(current+1).padStart(2,'0')} / ${String(this.scenes.length).padStart(2,'0')}`;
      }
      disconnectedCallback() {this.controller?.abort();this.controller=null;this.resize?.disconnect();cancelAnimationFrame(this.raf);this.raf=0;}
    }
    customElements.define('mokani-scene-wipes',MokaniSceneWipes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {



						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					


						var swiper = new Swiper(".swiper-container", {
							slidesPerView: 1,

								spaceBetween: 1,
								navigation: {
									nextEl: ".product-button-group .swiper-button-next-1",
									prevEl: ".product-button-group .swiper-button-prev-1",
								},
								pagination: {
									el: ".product-card-pagination",
									clickable: true,
								},
						});
						const initAnimated = () => {
							const blocks = document.querySelectorAll(".animated-block:not(.visible)");

							const observer = new IntersectionObserver(
									(entries) => {
											entries.forEach((entry) => {
													if (entry.isIntersecting) {
															const block = entry.target;
															block.classList.add("visible");
															observer.unobserve(block);
													}
											});
									},
									{ threshold: 0.1 } 
							);

							blocks.forEach((block) => {
									observer.observe(block);
							});
						};
						initAnimated();
						const cursorProgress = (productSwiper) => {
							const cursor = productSwiper.querySelector(".product__cursor");
							const cursorIcon = productSwiper.querySelector("#cursor-icon1");
						
							const animateCursor = (e) => {
								const contentRect = productSwiper.getBoundingClientRect();
								const x = e.clientX - contentRect.left - 12;
								const y = e.clientY - contentRect.top - 12;
						
								cursor.animate(
									{ transform: `translate(${x}px, ${y}px)` },
									{ duration: 300, fill: "forwards" }
								);
							};
						
							const getCursorClass = (position, width) => {
								return position < width / 2 ? "prev" : "next";
							};
						
							productSwiper.addEventListener("mousemove", (e) => {
								if (!e.target.closest(".link") &&
				!e.target.closest(".swiper-pagination") ) {
					cursor.classList.add("active");
				} else {
					cursor.classList.remove("active");
				}


								
						
								animateCursor(e);
						
								const position = e.clientX - productSwiper.getBoundingClientRect().left;
								cursor.dataset.type = getCursorClass(position, productSwiper.clientWidth);
						
								cursorIcon.className = cursor.dataset.type; 
						
								
							});
						
							productSwiper.addEventListener("mouseleave", () => {
								cursor.classList.remove("active");
							});
						};
						
		
							const productCards = document.querySelectorAll(".card--product_cursor");
							productCards.forEach((productCard) => cursorProgress(productCard));
							const buttonHoverEffects= () => {
	
	if (window.innerWidth < 1200) return;
	function wrapLetters(element) {
			const text = element.textContent.trim();
			element.innerHTML = '';

			const wrapperSpan = document.createElement('span');
			wrapperSpan.className = 'wrapper';

			Array.from(text).forEach((char, charIndex) => {
					const charSpan = document.createElement('span');
					charSpan.className = 'char';
					charSpan.textContent = char;
					charSpan.style.setProperty('--char-index', charIndex + 1);
					wrapperSpan.appendChild(charSpan);
			});

			element.appendChild(wrapperSpan);
	}

	document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
}

buttonHoverEffects()

					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();
})();
